import { useCallback, useState } from "react";
import "./SessionDismissible.css";

const STORAGE_PREFIX = "ovo_nudge_dismissed:";

export const NUDGE_IDS = {
  HOME_HERO_EMPTY: "home-hero-empty",
  HOME_CLOSING_FAST: "home-closing-fast",
  HOME_NICHE_BROWSE: "home-niche-browse",
  HOME_EXPLORE_GALLERY: "home-explore-gallery",
  HOME_REFERRAL_PILL: "home-referral-pill",
  GALLERY_STREAK: "gallery-streak",
  GALLERY_REENGAGE: "gallery-reengage",
  GALLERY_END: "gallery-end",
  DASH_PAYOUT: "dash-payout",
};

export function isNudgeDismissedThisSession(id) {
  if (!id) return false;
  try {
    return sessionStorage.getItem(STORAGE_PREFIX + id) === "1";
  } catch {
    return false;
  }
}

export function dismissNudgeForSession(id) {
  if (!id) return;
  try {
    sessionStorage.setItem(STORAGE_PREFIX + id, "1");
  } catch {
    /* ignore quota / private mode */
  }
}

/**
 * Session-only dismiss wrapper. Once dismissed, the child stays hidden
 * until the browser session ends. Pass a function child to render an
 * inline dismiss control (used by the referral feed pill).
 */
export default function SessionDismissible({
  id,
  children,
  className = "",
  tone = "light",
  hideDismiss = false,
  dismissLabel = "Dismiss",
}) {
  const [hidden, setHidden] = useState(() => isNudgeDismissedThisSession(id));

  const dismiss = useCallback(() => {
    dismissNudgeForSession(id);
    setHidden(true);
  }, [id]);

  if (!id || hidden) return null;

  const content = typeof children === "function" ? children({ dismiss }) : children;

  return (
    <div className={`session-dismissible session-dismissible--${tone}${className ? ` ${className}` : ""}`}>
      {content}
      {!hideDismiss && (
        <button
          type="button"
          className="session-dismissible-x"
          onClick={dismiss}
          aria-label={dismissLabel}
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      )}
    </div>
  );
}
